import { Card, CardHeader, CardTitle, CardDescription } from '@components/ui/card';
import Image from 'next/image';

export default function ClothingAndLocations() {
  return (
    <section className="">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-6 px-10">Customization</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Card className="p-4 rounded-2xl">
          <CardHeader>
            <CardTitle className="font-semibold text-xl text-accent">Choose from thousands of outfits</CardTitle>
            <CardDescription className="font-semibold text-xl leading-snug text-foreground">
              With thousands of outfit options, you can choose the perfect outfit for your headshot.
            </CardDescription>
          </CardHeader>
          <Image
            src="https://imagedelivery.net/9sCnq8t6WEGNay0RAQNdvQ/dc3a315f-1069-4cb3-a55c-1197c0501f00/public"
            alt="Headshot clothing customization options"
            width={1000}
            height={1000}
            className="w-full h-auto p-4 lg:p-10"
          />
        </Card>
        <Card className="rounded-2xl">
          <CardHeader className="p-10">
            <CardTitle className="font-semibold text-xl text-accent">Unlimited locations to choose from</CardTitle>
            <CardDescription className="font-semibold text-xl leading-snug text-foreground">
              Whether you need a professional headshot in a studio, on location, or in a home office, we have you
              covered.
            </CardDescription>
          </CardHeader>
          <Image
            src="https://imagedelivery.net/9sCnq8t6WEGNay0RAQNdvQ/04f1998b-18e0-49e8-d090-0263b3c3bc00/public"
            alt="Headshot clothing customization options"
            width={1000}
            height={1000}
            className="w-full h-auto"
          />
        </Card>
      </div>
    </section>
  );
}
